export const reviewKeys = {
  all: ['reviews'] as const,
  detailPrefix: ['reviews', 'detail'] as const,
  detail: (reviewId?: string) =>
    ['reviews', 'detail', reviewId ?? null] as const,
  messagesPrefix: ['reviews', 'messages'] as const,
  messages: (reviewId?: string) =>
    ['reviews', 'messages', reviewId ?? null] as const,
  drawerPrefix: ['reviews', 'drawer'] as const,
  drawer: (organizationID?: string, filters?: Record<string, unknown>) =>
    ['reviews', 'drawer', organizationID ?? null, filters ?? null] as const,
  gridPrefix: ['reviews', 'grid'] as const,
  grid: (organizationID?: string) =>
    ['reviews', 'grid', organizationID ?? null] as const,
  countPrefix: ['reviews', 'count'] as const,
  count: (organizationID?: string) =>
    ['reviews', 'count', organizationID ?? null] as const,
  notificationsPrefix: ['reviews', 'notifications'] as const,
  notifications: (organizationID?: string, userID?: string) =>
    [
      'reviews',
      'notifications',
      organizationID ?? null,
      userID ?? null,
    ] as const,
} as const
